import React from 'react';

// Don't add anything here. The document is rendered as an image in sfinx
export function DocumentPresentation() {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}
